import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import config from 'config'
import { mapToCssModules } from './Utils'

const { assets_url: assetsUrl } = config

const propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object,
  src: PropTypes.string,
  alt: PropTypes.string,
  circle: PropTypes.bool,
  rounded: PropTypes.bool,
  thumbnail: PropTypes.bool,
  withoutSiteUrl: PropTypes.bool,
}

const defaultProps = {
  tag: 'img',
  withoutSiteUrl: false,
}

export const Image = (props) => {
  const {
    className,
    cssModule,
    src,
    alt,
    circle,
    rounded,
    thumbnail,
    tag: Tag,
    withoutSiteUrl,
    ...attributes
  } = props

  const classes = mapToCssModules(classNames(
    className,
    {
      'img-circle': circle,
      'img-rounded': rounded,
      'img-thumbnail': thumbnail,
    }
  ), cssModule)

  return (
    <Tag
      {...attributes}
      src={withoutSiteUrl ? src : assetsUrl + src}
      alt={alt}
      className={classes}
    />
  )
}

Image.propTypes = propTypes
Image.defaultProps = defaultProps
